<template lang="pug">
  dv-maska-field(
    v-model="inputValue"
    v-bind="extraAttrs"
    v-on="inputListeners"
    :update-on="updateOn"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")

</template>

<script>
import DvMaskaField from './DvMaskaField.vue';

const COUNTY_CODE = 7;

export default {
  components: {
    DvMaskaField,
  },
  props: {
    updateOn: {
      type: String,
      default: 'input',
      validator: (value) => ['input', 'blur'].includes(value),
    },
    countryCode: {
      type: [Number, String],
      default: COUNTY_CODE,
    },
    value: {
      type: [Number, String],
      default: undefined,
    },
  },
  data() {
    return {
      inputValue: undefined,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.inputValue = val;
      },
      immediate: true,
    },
    inputValue: {
      handler(newValue, oldValue) {
        if (oldValue !== newValue) {
          this.$emit('input', this.serializeOutput(newValue));
        }
      },
      immediate: true,
    },
  },
  computed: {
    inputListeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
    maskaOptions() {
      const { countryCode } = this;
      return {
        mask: `+${countryCode} (###) ###-####`,
        preProcess: (value) => {
          const digits = this.serializeOutput(value);
          return Number(countryCode) === COUNTY_CODE && digits.length === 11 && digits.startsWith('8')
            ? `${countryCode}${digits.slice(1)}` : value;
        },
        tokens: {
          '#': {
            pattern: /[0-9]/,
          },
        },
        returnMasked: true,
      };
    },
    extraAttrs() {
      const { $attrs, countryCode, maskaOptions } = this;

      return {
        placeholder: `+${countryCode} (___) ___-____`,
        ...$attrs,
        maskaOptions,
      };
    },
  },
  methods: {
    serializeOutput(val) {
      return String(val ?? '').replace(/\D/g, '');
    },
  },
};
</script>
